import { Box, Breadcrumbs, Button, Checkbox, Grid, Table, TableBody, TableContainer, TableHead, Typography, useTheme } from '@mui/material';
import React, { useState } from 'react'
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useDispatch } from 'react-redux';
import usePageLoader from '../../Redux/hooks/usePageLoader';
import useSnackBar from '../../Redux/hooks/useSnackBar';
import { useCommonStyles } from '../../utils';
import StyledTableRow from '../Common/StyledTableRow';
import StyledTableCell from '../Common/StyledTableCell';
import NoDataFound from '../Common/NoDataFound';
import ErrorHandler from '../../lib/errorHandler';
import CommonTextField from '../Common/CommonTextField';
import CommonAutoComplete from '../Common/CommonAutoComplete';
import { addRoleManagement, getPermission, updateRoleManagement } from '../../Redux/Actions/RoleManagement';
import { handleAlphabetKeyDown, Regex } from '../../utils/regex';
import ErrorMessage from '../Common/ErrorMessage';

const AddNewUserAndRole = ({ roleOptions, setIsOpenAddNewUserRole, setData, data, _getRoleManagement, selectedItem, setSelectedItem, setPermissionList, permissionList, selectedRows, setSelectedRows, setSearchValue }) => {
    // ============== Hooks ==============
    const theme = useTheme();
    const { classes } = useCommonStyles();
    const dispatch = useDispatch();
    const setFullPageLoader = usePageLoader();
    const { setSnackBar } = useSnackBar();

    // ============== States ==============
    const [errors, setErrors] = useState({});

    // ============== Handler ===============
    const breadcrumbs = [
        <Typography color={theme.palette.bgBlack.main} sx={{ opacity: "70%", cursor: "pointer" }} fontFamily={'Satoshi-Medium'} onClick={() => handleClose()}>
            User & Role
        </Typography>,
        <Typography color={theme.palette.bgBlack.main} fontFamily={'Satoshi-Medium'}>
            {`${selectedItem?._id ? "Edit" : "Add New"} User & Role`}
        </Typography>,
    ];

    const handleClose = () => {
        setIsOpenAddNewUserRole(false)
        setData({})
        setSelectedItem({})
        setSelectedRows([])
        _getRoleManagement();
        setSearchValue("")
        const resetPermissionList = permissionList?.map((ele) => {
            return {
                ...ele,
                edit: false,
                view: false,
            }
        })
        setPermissionList(resetPermissionList)
    }

    const handleChange = (name, value) => {
        setData({ ...data, [name]: value })
    }
    const handleSelectAll = (event) => {
        setSelectedRows(event.target.checked ? permissionList : []);
    };
    const handleRowSelect = (row) => {
        setSelectedRows((prev) => {
            const isSelected = prev.find((item) => item.sectionName === row.sectionName);
            return isSelected ? prev.filter((item) => item.sectionName !== row.sectionName) : [...prev, row];
        });
    };

    const handleChangeItem = (row, name, value) => {
        const updatedData = permissionList?.map((ele) =>
            ele?.sectionName == row?.sectionName ? { ...ele, [name]: value } : { ...ele }
        )
        const updatedDataRow = selectedRows?.map((ele) =>
            ele?.sectionName == row?.sectionName ? { ...ele, [name]: value } : { ...ele }
        )
        setSelectedRows(updatedDataRow)
        setPermissionList(updatedData)
    }

    const validation = () => {
        let formIsValid = true;
        let errors = {}

        if (!data?.userName) {
            formIsValid = false;
            errors["userName"] = "* Please enter userName";
        }
        if (!data?.role?.name) {
            formIsValid = false;
            errors["role"] = "* Please select role.";
        }
        if (!data?.emailId) {
            formIsValid = false;
            errors["emailId"] = "* Please enter email";
        } else if (!data.emailId?.match(Regex.emailRegex)) {
            formIsValid = false;
            errors["invalidEmail"] = "* Invalid email Address";
        }

        setErrors(errors)
        return formIsValid
    }
    // ============= add Inventory Field API =============
    const _addUpdateUserRole = async () => {
        if (validation()) {
            setFullPageLoader(true);
            let response;
            let body = {
                "userName": data?.userName,
                "email": data?.emailId,
                "role": data?.role?.name,
                "permission": selectedRows,
            }
            if (selectedItem?._id) {
                body._id = selectedItem?._id
            }
            const fn = selectedItem?._id ? updateRoleManagement : addRoleManagement
            response = await dispatch(fn(body));
            let error = await ErrorHandler(response, setSnackBar);
            if (error) {
                if (response?.payload?.data) {
                    (async () => {
                        const data = await dispatch(getPermission());
                    })();
                    setSnackBar("success", response?.payload?.message)
                    handleClose()
                }
                setFullPageLoader(false);
            }
            setFullPageLoader(false);
        }
    }

    return (
        <Grid container padding={"25px"} spacing={2} height={"fit-content"}>
            <Grid item xs={12}>
                <Typography fontFamily={"Satoshi-Bold"} fontSize={"28px"}> {`${selectedItem?._id ? "Edit" : "Add New"} User & Role`}</Typography>
                <Breadcrumbs
                    separator={<NavigateNextIcon fontSize="small" />}
                    aria-label="breadcrumb"
                >
                    {breadcrumbs}
                </Breadcrumbs>
            </Grid>
            <Grid item xs={12}>
                <Box sx={{ bgcolor: theme.palette.bgWhite.main, borderRadius: "26px", padding: "25px" }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Typography fontFamily={"Satoshi-Bold"} fontSize={"20px"}>{`${selectedItem?._id ? "Edit" : "Create New"} User & Role`}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <CommonTextField
                                valid
                                type="text"
                                label="User Name"
                                placeholder="Enter The User Name"
                                name="userName"
                                disabled={selectedItem?._id ? true : false}
                                value={data.userName}
                                onChange={(e) => handleChange("userName", e.target.value)}
                                onKeyDown={handleAlphabetKeyDown}
                            />
                            <ErrorMessage text={!data?.userName ? errors?.userName : ""} />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <CommonTextField
                                valid
                                type="text"
                                label="Email Id"
                                placeholder="Enter The Email Id"
                                name="emailId"
                                disabled={selectedItem?._id ? true : false}
                                value={data.emailId}
                                onChange={(e) => handleChange("emailId", e.target.value)}
                            />
                            <ErrorMessage text={!data.emailId ? errors?.emailId : ""} />
                            <ErrorMessage text={(data.emailId && !data.emailId?.match(Regex.emailRegex)) ? errors?.invalidEmail : ""} />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <CommonAutoComplete
                                valid
                                label={"Role"}
                                placeholder="Select Role"
                                disabled={selectedItem?._id ? true : false}
                                options={roleOptions || []}
                                getOptionLabel={(option) => option?.name || ""}
                                value={data?.role || null}
                                onChange={(e, newValue) => handleChange("role", newValue)}
                            />
                            <ErrorMessage text={!data?.role?.name ? errors?.role : ""} />
                        </Grid>
                        <Grid item xs={12}>
                            <Box sx={{ borderRadius: "26px", border: "1px solid", backgroundColor: theme.palette.bgWhite.main, borderColor: "#c8d3d96e", borderTop: "none" }}>
                                <TableContainer>
                                    <Table >
                                        <TableHead>
                                            <StyledTableRow isHeader style={{ backgroundColor: "#E9E9E9" }}>
                                                <StyledTableCell>
                                                    <Checkbox checked={selectedRows.length === permissionList?.length} onChange={handleSelectAll} sx={{ paddingTop: "4px" }} />
                                                    {"Modules"}
                                                </StyledTableCell>
                                                <StyledTableCell align='center'>
                                                    {"Permissions"}
                                                </StyledTableCell>
                                            </StyledTableRow>
                                        </TableHead>
                                        <TableBody>
                                            {permissionList?.length > 0 ?
                                                permissionList?.map((row, index) => (
                                                    <React.Fragment key={index}>
                                                        <StyledTableRow>
                                                            <StyledTableCell>
                                                                <Checkbox
                                                                    defaultChecked={selectedRows.some((item) => item.sectionName === row.sectionName)}
                                                                    checked={selectedRows.some((item) => item.sectionName === row.sectionName)}
                                                                    onChange={() => handleRowSelect(row)}
                                                                    sx={{ paddingTop: "4px" }}
                                                                />
                                                                {row?.sectionName}
                                                            </StyledTableCell>
                                                            <StyledTableCell>
                                                                <Box display={"flex"} alignItems={"center"} justifyContent={"center"} gap={6}>
                                                                    <Box display={"flex"} alignItems={"center"}>
                                                                        <Checkbox
                                                                            checked={row?.view}
                                                                            onChange={(e) => handleChangeItem(row, "view", e.target.checked)}
                                                                        />
                                                                        <Typography fontFamily={"Satoshi-Light"}>View</Typography>
                                                                    </Box>
                                                                    <Box display={"flex"} alignItems={"center"}>
                                                                        <Checkbox
                                                                            checked={row?.edit}
                                                                            onChange={(e) => handleChangeItem(row, "edit", e.target.checked)}
                                                                        />
                                                                        <Typography fontFamily={"Satoshi-Light"}>Edit</Typography>
                                                                    </Box>
                                                                </Box>
                                                            </StyledTableCell>
                                                        </StyledTableRow>
                                                    </React.Fragment>
                                                ))
                                                :
                                                <StyledTableRow>
                                                    <StyledTableCell colSpan={12}>
                                                        <NoDataFound />
                                                    </StyledTableCell>
                                                </StyledTableRow>
                                            }
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Box>
                        </Grid>
                        <Grid item xs={12} mt={1} display={"flex"} gap={2}>
                            <Button className={classes.cancelButton} onClick={() => handleClose()} >Cancel</Button>
                            <Button className={classes.saveButton} onClick={() => _addUpdateUserRole()}>{selectedItem?._id ? "Update Role" : "Create Role"}</Button>
                        </Grid>
                    </Grid>
                </Box>
            </Grid>
        </Grid>
    )
}

export default AddNewUserAndRole